<template lang="pug">
div
  el-row(:span="24")
    el-col(:span="12")
      app-display(
        label="Possui CAR?",
        :content="imovel.possuiCar ? 'Sim' : 'Não'",
      )
    el-col(:span="12", v-if="imovel.numeroReciboCar",)
      app-display(
        :label="labelImovel.numeroRecibo",
        :content="imovel.numeroReciboCar",
        :marginBottom="true",
      )
    el-col(:span="12", v-if="imovel.viasDeAcesso")
      app-display(
        label="Roteiro de acesso:",
        :content="imovel.viasDeAcesso",
      )
    el-col(:span="12", v-if="imovel.nome")
      app-display(
        label="Nome do Imóvel:",
        :content="imovel.nome",
      )
    el-col(:span="12", v-if="imovel.gleba")
      app-display(
        label="Gleba:",
        :content="imovel.gleba"
      )
    el-col(:span="12", v-if="imovel.area")
      app-display(
        label="Área:",
        :content="formatterDecimal(imovel.area) + ' hectare(s)'",
      )
    el-col(:span="12")
      app-display(
        label="Descrição de acesso:",
        :content="imovel.descricaoAcesso",
        v-if="imovel.descricaoAcesso"
      )
    el-col(:span="12")
      app-display(
        label="Há eletrificação no imóvel?",
        :content="imovel.possuiEletrificacao ? 'Sim' : 'Não'"
      )
    el-col(:span="12", v-if="imovel.tipoEletrificacao")
      app-display(
        label="Qual o tipo de eletrificação?",
        :content="imovel.tipoEletrificacao"
      )
    el-col(:span="12")
      app-display(
        label="Possui acesso à rodovias no imóvel?",
        :content="imovel.possuiAcessoRodovia ? 'Sim' : 'Não'"
      )
    el-col(:span="12")
      app-display(
        label="Qual o tipo de acesso à rodovia?",
        :content="imovel.tipoAcessoRodovia"
      )
    el-col(:span="12", v-if="imovel.possuiAcessoRodovia === true")
      app-display(
        label="O acesso pela rodovia é pavimentado?",
        :content="imovel.isRodoviaPavimentada"
      )
    el-col(:span="12")
      app-display(
        label="Tem interesse ecológico para preservação de ecossistemas?",
        :content="imovel.possuiInteresseEcologico ? 'Sim' : 'Não'"
      )
    el-col(:span="12", v-if="imovel.possuiInteresseEcologico === true")
      app-display(
        label="O acesso pela rodovia é pavimentado?",
        :content="imovel.interessesEcologicos"
      )
    el-col(:span="12")
      app-display(
        label="Tem projeto de recuperação da área degradada?",
        :content="imovel.possuiProjetoRecuperacao ? 'Sim' : 'Não'"
      )
    el-col(:span="12")
      app-display(
        label="Tem efetiva recuperação de área degradada?",
        :content="imovel.isRecuperacaoAreaDegradada ? 'Sim' : 'Não'"
      )
    el-col(:span="12", v-if="imovel.areaCerrado")
      app-display(
        label="Área cerrado (ha):",
        :content="imovel.areaCerrado"
      )
    el-col(:span="12", v-if="imovel.areaReservaLegalCerrado")
      app-display(
        label="Área de Reserva Legal cerrado (ha):",
        :content="imovel.areaReservaLegalCerrado"
      )
    el-col(:span="12", v-if="imovel.porcentagemCerrado")
      app-display(
        label="Porcentagem cerrado (%):",
        :content="imovel.porcentagemCerrado"
      )
    el-col(:span="12", v-if="imovel.areaFloresta")
      app-display(
        label="Área floresta (ha):",
        :content="imovel.areaFloresta"
      )
    el-col(:span="12", v-if="imovel.areaReservaLegalFloresta")
      app-display(
        label="Área de Reserva Legal floresta (ha):",
        :content="imovel.areaReservaLegalFloresta"
      )
    el-col(:span="12", v-if="imovel.porcentagemFloresta")
      app-display(
        label="Porcentagem floresta (%):",
        :content="imovel.porcentagemFloresta"
      )

</template>

<script>
import AppDisplay from '@/components/AppDisplay'
import AppCollapse from '@/components/AppCollapse'
import moment from 'moment'
import utils from '@/utils/utils'
import { mapState } from 'vuex'
const { labelVisualizacaoProcesso } = require('@/utils/' + process.env.ESTADO + '/regrasAnalise').default

export default {

  components: {
    AppDisplay,
    AppCollapse
  },

  props: {
    cadastroOriginal: {
      type: Object,
      required: true
    }
  },

  methods: {
    getUnidadeAno (ano) {
      if (!ano) return '-'
      return ano <= 1 ? ano + ' ano' : ano + ' anos'
    },
    getDate (date) {
      return moment(new Date(date)).format('DD/MM/YYYY')
    },
    formatterDecimal (value) {
      return utils.format(value, { prefix: '', suffix: '', thousands: '.', decimal: ',', precision: 4 })
    }
  },
  computed: {
    ...mapState({
      ESTADO: state => state.userInterface.dadosEstado.ESTADO
    }),

    imovel () {
      return this.cadastroOriginal.imovel
    }
  },
  data () {
    return {
      labelImovel: labelVisualizacaoProcesso.etapaImovel
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/informacoesCadastro/InformacoesImovelRr.vue